import { render, staticRenderFns } from "./msgTemplate.vue?vue&type=template&id=1a1ea737"
import script from "./msgTemplate.vue?vue&type=script&lang=js"
export * from "./msgTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports